<template>
  <div class="container features">
    <div class="section-title">
      <h2>{{msg}}</h2>
    </div>
    <div class="row">
      <div class="col-md-4" v-for="item in items" :key="item.heading">
        <div class="features-item">
            <h3>{{item.heading}}</h3>
            <div class="img">
              <img :src="item.img" alt="special-image">
            </div>
            <p>{{item.text}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Special',
  data : function () {
    return {
      msg : 'our specials',
      items:[
        { heading:'Lorem ipsum dolor',
          img: 'assets/images/specials/1.jpg',
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sed commodo.'
        },
        { heading:'Consectetur adipiscing',
          img: 'assets/images/specials/2.jpg',          
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sed commodo.'
        },
        { heading:'Duis sed dapibus',
          img: 'assets/images/specials/3.jpg',          
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sed commodo.'
        }
      ]
    }
  } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.features {padding: 60px 0;}

.features .features-item {margin:30px 0;}

.features img {
	margin: 30px auto 20px;
}
.features h3{
	font-size: 24px;
  text-transform: capitalize;
}
.features p {
	line-height:1.8;
	margin: 15px 0 30px;
}
</style>
